import { cn } from "./classNames-DkX30VJU.js";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/FieldBox/FieldBoxDescription.tsx
const FieldBoxDescription = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	...props,
	"data-slot": "field-box-description",
	className: cn("tw:text-xs", "tw:text-muted-foreground", "tw:group-has-[:disabled]/field-box:opacity-disabled", className)
});
// src/components/FieldBox/FieldBoxTitle.tsx
const FieldBoxTitle = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	...props,
	"data-slot": "field-box-title",
	className: cn("tw:text-sm", "tw:font-medium", "tw:text-foreground", "tw:group-has-[:disabled]/field-box:cursor-not-allowed", "tw:group-has-[:disabled]/field-box:opacity-disabled", className)
});
// src/components/FieldBox/styles.ts
const fieldBoxVariants = cva([
	"tw:group/field-box",
	"tw:m-0",
	"tw:inline-flex",
	"tw:gap-3",
	"tw:items-start",
	"tw:cursor-pointer",
	"tw:select-none",
	"tw:has-[:disabled]:cursor-not-allowed"
], {
	variants: { variant: {
		default: [],
		boxed: [
			"tw:rounded-lg",
			"tw:border",
			"tw:border-solid",
			"tw:border-border",
			"tw:p-3",
			"tw:transition-colors",
			"tw:has-[[data-state=checked]]:border-primary",
			"tw:has-[[data-state=checked]]:bg-selected",
			"tw:has-[[data-state=checked]]:text-[var(--selected-foreground,currentColor)]",
			"tw:has-[[data-state=indeterminate]]:border-primary",
			"tw:has-[[data-state=indeterminate]]:bg-selected",
			"tw:has-[[data-state=indeterminate]]:text-[var(--selected-foreground,currentColor)]"
		]
	} },
	defaultVariants: { variant: "default" }
});
// src/components/FieldBox/FieldBox.tsx
const FieldBoxRoot = ({ ref, className, variant, position = "start", control, children, ...rest }) => /* @__PURE__ */ jsxs("label", {
	...rest,
	ref,
	className: cn(fieldBoxVariants({
		variant,
		className
	}), position === "end" && "tw:flex-row-reverse"),
	children: [/* @__PURE__ */ jsx("span", {
		className: "tw:inline-flex tw:min-h-5 tw:shrink-0 tw:items-center tw:group-has-[[data-slot=field-box-description]]/field-box:mt-0.5",
		children: control
	}), children != null && /* @__PURE__ */ jsx("span", {
		className: "tw:flex tw:flex-1 tw:flex-col tw:gap-0.5",
		children
	})]
});
const FieldBox = Object.assign(FieldBoxRoot, {
	Title: FieldBoxTitle,
	Description: FieldBoxDescription
});
export { FieldBox };

//# sourceMappingURL=FieldBox-DdSdJ3ZN.js.map